import { render, staticRenderFns } from "./InvestorKycStatus.vue?vue&type=template&id=187df336&"
import script from "./InvestorKycStatus.vue?vue&type=script&lang=js&"
export * from "./InvestorKycStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports